import { IAdminDashReports } from '../../shared/interfaces/admin-dash-reports';
import { LocalDb } from './database.service';
import { Injectable } from '@angular/core';
import Dexie from 'dexie';

export interface AdminDashReportsWithId extends IAdminDashReports {
  id: number;
}

@Injectable()
export class AdminDashReportsService {
  table: Dexie.Table<AdminDashReportsWithId, number>;

  constructor(private readonly localDb: LocalDb) {
    this.table = this.localDb.table('adminDashReports');
  }

  get(id) {
    return this.table.get(id);
  }

  getAll() {
    return this.table.toArray();
  }

  add(data, id) {
    return this.table.add(data, id);
  }

  put(data, id) {
    return this.table.put(data, id);
  }

  update(id, data) {
    return this.table.update(id, data);
  }

  remove(id) {
    return this.table.delete(id);
  }

  clear() {
    return this.table.clear();
  }
}
